import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLoading } from '../check_login';
import generateText from './generate_text';
import { useNavigate } from 'react-router-dom';
import { FiThumbsUp, FiThumbsDown, FiMail, FiSmartphone, FiMessageSquare, FiGlobe } from 'react-icons/fi';
import { motion } from 'framer-motion';
import campaignTypesConfig from '../../creative_types/types';
import '../../../assets/css/ai-assistant.css';

// Функция за вземане на OpenAI API ключ от сървъра
const getApiKey = async () => {
    try {
        const response = await axios.get('/openai/api-key');
        return response.data.apiKey;
    } catch (error) {
        console.error('Error fetching API key:', error);
        throw new Error('Failed to get API key');
    }
};

// Функция за генериране на заглавие чрез OpenAI
const generateHeadline = async (text) => {
    try {
        const apiKey = await getApiKey();
        const response = await axios.post('https://api.openai.com/v1/chat/completions', {
            model: 'gpt-4',
            messages: [
                {
                    role: 'system', 
                    content: 'You are a helpful assistant that generates a meaningful headline based on a given text.'
                },
                {
                    role: 'user',
                    content: `Generate a meaningful headline based on the following text: "${text}" max 35 symbols.`
                }
            ],
            //max_tokens: 50,
            temperature: 0.7,
        }, {
            headers: {
                'Authorization': `Bearer ${apiKey}`,
                'Content-Type': 'application/json',
            },
        });

        return response.data.choices[0].message.content;
    } catch (error) {
        console.error('Error generating headline with OpenAI:', error);
        return null;
    }
};

const generateSubjectline1 = async (text) => {
    try {
        const apiKey = await getApiKey();
        const response = await axios.post('https://api.openai.com/v1/chat/completions', {
            model: 'gpt-4',
            messages: [    
     
                {
                    role: 'user',
                    content: `Generate a meaningful Subject line for email based on the following text: "${text}"`
                }
            ],
            //max_tokens: 50,
            temperature: 0.7,
        }, {
            headers: {
                'Authorization': `Bearer ${apiKey}`,
                'Content-Type': 'application/json',
            },
        });

        return response.data.choices[0].message.content;
    } catch (error) {
        console.error('Error generating headline with OpenAI:', error);
        return null;
    }
};


const generateSubjectline2 = async (text) => {
    try {
        const apiKey = await getApiKey();
        const response = await axios.post('https://api.openai.com/v1/chat/completions', {
            model: 'gpt-4',
            messages: [    
          
                {
                    role: 'user',
                    content: `Generate a meaningful Subject line for email based on the following text: "${text}"`
                }
            ],
            //max_tokens: 50,
            temperature: 0.7,
        }, {
            headers: {
                'Authorization': `Bearer ${apiKey}`,
                'Content-Type': 'application/json',
            },
        });

        return response.data.choices[0].message.content;
    } catch (error) {
        console.error('Error generating headline with OpenAI:', error);
        return null;
    }
};

const generateSubjectline3 = async (text) => {
    try {
        const apiKey = await getApiKey();
        const response = await axios.post('https://api.openai.com/v1/chat/completions', {
            model: 'gpt-4',
            messages: [    
            
                {
                    role: 'user',
                    content: `Generate a meaningful Subject line for email based on the following text: "${text}"`
                }
            ],
            //max_tokens: 50,
            temperature: 0.7,
        }, {
            headers: {
                'Authorization': `Bearer ${apiKey}`,
                'Content-Type': 'application/json',
            },
        });

        return response.data.choices[0].message.content;
    } catch (error) {
        console.error('Error generating headline with OpenAI:', error);
        return null;
    }
};

const generatePreHeader = async (text) => {
    try {
        const apiKey = await getApiKey();
        const response = await axios.post('https://api.openai.com/v1/chat/completions', {
            model: 'gpt-4',
            messages: [    
        
                {
                    role: 'user',
                    content: `Generate a meaningful Pre Header for email based on the following text: "${text}"`
                }
            ],
            //max_tokens: 50,
            temperature: 0.7,
        }, {
            headers: {
                'Authorization': `Bearer ${apiKey}`,
                'Content-Type': 'application/json',
            },
        });

        return response.data.choices[0].message.content;
    } catch (error) {
        console.error('Error generating headline with OpenAI:', error);
        return null;
    }
};

const translateWithOpenAI = async (text, targetLang) => {
    try {
        const apiKey = await getApiKey();
        const response = await axios.post('https://api.openai.com/v1/chat/completions', {
            model: 'gpt-4',
            messages: [
                {
                    role: 'system', 
                    content: 'You are a helpful assistant that translates text into different languages.'
                },
                {
                    role: 'user',
                    content: `Translate the following text to ${targetLang}: "${text}"`
                }
            ],
            max_tokens: 500,
            temperature: 0.7,
        }, {
            headers: {
                'Authorization': `Bearer ${apiKey}`,
                'Content-Type': 'application/json',
            },
        });

        return response.data.choices[0].message.content;
    } catch (error) {
        console.error('Error translating text with OpenAI:', error);
        return null;
    }
};

// Function to detect language of generated content
const detectLanguageWithOpenAI = async (text) => {
    try {
        const apiKey = await getApiKey();
        const response = await axios.post('https://api.openai.com/v1/chat/completions', {
            model: 'gpt-4',
            messages: [
                {
                    role: 'system', 
                    content: 'You are a helpful assistant that detects the language of text. Respond only with the language code (e.g., "en", "bg", "de", "fr", "es", etc.). If uncertain, respond with "en".'
                },
                {
                    role: 'user',
                    content: `What language is this text written in? Text: "${text}"`
                }
            ],
            max_tokens: 10,
            temperature: 0.1,
        }, {
            headers: {
                'Authorization': `Bearer ${apiKey}`,
                'Content-Type': 'application/json',
            },
        });

        return response.data.choices[0].message.content.trim().toLowerCase();
    } catch (error) {
        console.error('Error detecting language with OpenAI:', error);
        return 'en'; // fallback to English
    }
};

// Helper функции за броене на символи и думи
const calculateSMSStats = (text) => {
    if (!text) return { totalCount: 0, totalSMS: 0, gsm: 0, unicode: 0, nextPart: 160 };
    
    const textLength = text.length;
    const gsmChars = /^[A-Za-z0-9@£$¥èéùìòÇØøÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&'()*+,\-./:;<=>?¡ÄÖÑÜ§¿äöñüà^{}\\[\]\|~€]*$/;
    const isUnicode = !gsmChars.test(text);
    
    let smsLimit = isUnicode ? 70 : 160;
    let totalSMS = Math.ceil(textLength / smsLimit);
    let nextPart = smsLimit - (textLength % smsLimit);
    
    if (nextPart === smsLimit) nextPart = 0;
    
    return {
        totalCount: textLength,
        totalSMS: totalSMS,
        gsm: isUnicode ? 0 : textLength,
        unicode: isUnicode ? textLength : 0,
        nextPart: nextPart
    };
};

const calculateTextStats = (text) => {
    if (!text) return { characters: 0, words: 0 };
    
    // Strip HTML tags for accurate counting
    const plainText = text.replace(/<[^>]*>/g, '');
    const words = plainText.trim().split(/\s+/).filter(word => word.length > 0).length;
    
    return {
        characters: plainText.length,
        words: words
    };
};

const ContentGenerator = ({pageTitle}) => {
    const [currentStep, setCurrentStep] = useState(1);
    const [campaignType, setCampaignType] = useState(''); // Campaign type (Marketing, System, etc.)
    const [creativeTypes, setCreativeTypes] = useState([]); // Multiple creative formats (Email, SMS, etc.)
    const [contentType, setContentType] = useState('');
    const [tone, setTone] = useState('');
    const [briefDescription, setBriefDescription] = useState('');
    const [contentName, setContentName] = useState('');
    const [generatedContents, setGeneratedContents] = useState({}); // Multiple generated contents
    const [isGenerating, setIsGenerating] = useState(false);
    const [likedContents, setLikedContents] = useState({}); // Track likes for each creative type
    const [channels, setChannels] = useState([]);
    const [selectedLanguages, setSelectedLanguages] = useState([]);
    const [showChannels, setShowChannels] = useState(false);
    const [translations, setTranslations] = useState({});
    const [activeLanguages, setActiveLanguages] = useState([]);
    const { showLoading, hideLoading } = useLoading();
    const navigate = useNavigate();
    const toneOptions = ['Normal','Aggresive','Calm', 'Excited', 'Professional', 'Fun', 'Sales', 'Legal'];

    // Параметри за различните типове съдържание
    const [headlines, setHeadlines] = useState({});
    const [subjectLines, setSubjectLines] = useState({});
    const [preHeaders, setPreHeaders] = useState({});
    const [btnName, setBtnName] = useState('Learn More');
    const [isCreating, setIsCreating] = useState(false); 
    const [creationProgress, setCreationProgress] = useState(0);
    const [currentCreatingType, setCurrentCreatingType] = useState('');
    const [totalCreatives, setTotalCreatives] = useState(0);
    
    useEffect(() => {
        const fetchActiveLanguages = async () => {
            try {
                const response = await axios.get("/language/view");
                const activeLangs = response.data.filter(language => language.status === "active").map(language => ({
                    code: language.code,
                    _id: language._id
                }));
                setActiveLanguages(activeLangs);
                
                // Auto-select English if available (content is generated in English)
                const englishLanguage = activeLangs.find(lang => 
                    lang.code.toLowerCase() === 'en' || 
                    lang.code.toLowerCase() === 'eng' || 
                    lang.code.toLowerCase() === 'english'
                );
                
                if (englishLanguage && selectedLanguages.length === 0) {
                    setSelectedLanguages([englishLanguage._id]);
                }
            } catch (error) {
                console.error("Error fetching active languages:", error);
            }
        };
        fetchActiveLanguages();
    }, []);

    // Auto-select content language when content is generated
    useEffect(() => {
        const autoSelectLanguage = async () => {
            if (Object.keys(generatedContents).length > 0 && selectedLanguages.length === 0 && activeLanguages.length > 0) {
                // Get first generated content for language detection
                const firstContent = Object.values(generatedContents)[0];
                
                if (firstContent && firstContent.trim()) {
                    // Detect the language of generated content
                    const detectedLangCode = await detectLanguageWithOpenAI(firstContent);
                    
                    // Find matching language in active languages
                    const matchingLanguage = activeLanguages.find(lang => {
                        const langCode = lang.code.toLowerCase();
                        return langCode === detectedLangCode || 
                               langCode === detectedLangCode.substring(0, 2) ||
                               langCode.startsWith(detectedLangCode) ||
                               detectedLangCode.startsWith(langCode);
                    });
                    
                    if (matchingLanguage) {
                        setSelectedLanguages([matchingLanguage._id]);
                    } else {
                        // Fallback to English if available
                        const englishLanguage = activeLanguages.find(lang => 
                            lang.code.toLowerCase() === 'en' || 
                            lang.code.toLowerCase() === 'eng' || 
                            lang.code.toLowerCase() === 'english'
                        );
                        
                        if (englishLanguage) {
                            setSelectedLanguages([englishLanguage._id]);
                        }
                    }
                }
            }
        };
        
        autoSelectLanguage();
    }, [generatedContents, activeLanguages, selectedLanguages.length]);

    const handleNextStep = () => {
        if (currentStep < 3) {
            setCurrentStep(currentStep + 1);
        }
    };

    const canProceedToNextStep = () => {
        switch(currentStep) {
            case 1: return campaignType !== '' && creativeTypes.length > 0 && tone !== ''; // Setup complete
            case 2: return contentType.trim() !== '' && briefDescription.trim() !== ''; // Content & brief provided
            case 3: return Object.keys(generatedContents).length > 0 && Object.values(likedContents).some(liked => liked === true); // At least one content generated and liked
            default: return false;
        }
    };

    const [originalTexts, setOriginalTexts] = useState({}); // Съхраняване на оригиналните текстове

    // Get placeholder text based on selected creative types
    const getBriefPlaceholder = () => {
        if (creativeTypes.length === 0) {
            return "Provide more details about your content (target audience, key message, call to action, etc.)";
        }
        
        let placeholder = "Provide details for your content:\n\n";
        
        creativeTypes.forEach(type => {
            switch(type) {
                case 'Email':
                    placeholder += "📧 EMAIL:\n• Target audience\n• Key message and value proposition\n• Call-to-action\n• Subject line ideas\n• Pre-header hints\n• Email tone and style\n\n";
                    break;
                case 'SMS':
                    placeholder += "📱 SMS:\n• Target audience\n• Key message (must be concise - max 160 characters)\n• Call-to-action\n• Urgency level\n\n";
                    break;
                case 'Push-Notification':
                    placeholder += "🔔 PUSH NOTIFICATION:\n• Target audience\n• Key message\n• Call-to-action\n• Notification title ideas\n• Urgency/timing\n\n";
                    break;
                case 'Popup':
                    placeholder += "💬 POPUP:\n• Target audience\n• Key message\n• Call-to-action\n• Headline ideas\n• Design preferences\n\n";
                    break;
            }
        });
        
        return placeholder.trim();
    };

    const handleGenerate = async () => {
        setIsGenerating(true);
        showLoading();
        
        const newGeneratedContents = {};
        const newHeadlines = {};
        const newSubjectLines = {};
        const newPreHeaders = {};
        const newOriginalTexts = {};
        
        // Generate content for each selected creative type
        for (const creativeType of creativeTypes) {
            // Create specific prompt based on creative type and campaign type
            let prompt = '';
            const campaignContext = `Campaign Type: ${campaignType}\nContent Type: ${contentType}\nTone: ${tone}\nBrief: ${briefDescription}`;
            
            switch(creativeType) {
                case 'Email':
                    prompt = `Create an email campaign for a ${campaignType.toLowerCase()} campaign with the following details:
                    ${campaignContext}
                    
                    Please provide ONLY the main email body content with proper HTML formatting:
                    - Use <p> tags for paragraphs
                    - Add <br> tags between paragraphs for proper spacing
                    - Use <br> for line breaks within paragraphs
                    - Use <strong> or <b> tags for important text and key points
                    - Use <em> or <i> tags for emphasis where appropriate
                    - Structure the content with proper spacing for readability
                    - Make important offers, benefits, or calls-to-action stand out with bold formatting
                    - Do NOT include subject lines, pre-header, or headline - just the email body text
                    - Do NOT add quotation marks around the content
                    - Return only the formatted HTML text content
                    Keep it engaging and appropriate for the selected tone.`;
                    break;
                    
                case 'SMS':
                    prompt = `Create a short SMS message (max 160 characters) for a ${campaignType.toLowerCase()} campaign:
                    ${campaignContext}
                    
                    Provide ONLY plain text without any HTML formatting, emojis, or special characters.
                    Do NOT add quotation marks around the content.
                    Keep it concise, impactful, and within SMS character limits.`;
                    break;
                    
                case 'Push-Notification':
                    prompt = `Create a push notification message for a ${campaignType.toLowerCase()} campaign:
                    ${campaignContext}
                    
                    Provide ONLY the notification message body in plain text (max 240 characters). 
                    Do not include HTML formatting, emojis, or special characters.
                    Do not include the title/headline.
                    Do NOT add quotation marks around the content.`;
                    break;
                    
            case 'Popup':
                prompt = `Create popup body text for a ${campaignType.toLowerCase()} campaign:
                ${campaignContext}
                
                Please provide ONLY the main popup body text with proper HTML formatting:
                - Use <p> tags for paragraphs
                - Add <br> tags between paragraphs for proper spacing
                - Use <br> for line breaks within paragraphs
                - Use <strong> or <b> tags for important text and key points
                - Use <em> or <i> tags for emphasis where appropriate
                - Structure the content with proper spacing for readability
                - Make important offers, benefits, or calls-to-action stand out with bold formatting
                - Do NOT include headline or CTA button text
                - Do NOT add quotation marks around the content
                - Return only the formatted HTML text content`;
                break;                default:
                    prompt = `${campaignContext}`;
            }
            
            const text = await generateText(prompt, tone, selectedLanguages);
            newGeneratedContents[creativeType] = text;
            newOriginalTexts[creativeType] = text;
        
            // Generate additional elements based on creative type
            if (creativeType === 'Email') {
                // Generate headline for email
                const headlinePrompt = `Create a compelling email headline for a ${campaignType.toLowerCase()} email campaign. Content: ${contentType}. Brief: ${briefDescription}. Max 50 characters.`;
                const generatedHeadline = await generateHeadline(headlinePrompt);
                newHeadlines[creativeType] = generatedHeadline || 'Email Headline';

                // Generate subject lines
                const subjectPrompt = `Create email subject lines for a ${campaignType.toLowerCase()} campaign. Content: ${contentType}. Brief: ${briefDescription}`;
                const generatedSubjectline1 = await generateSubjectline1(subjectPrompt);
                const generatedSubjectline2 = await generateSubjectline2(subjectPrompt);
                const generatedSubjectline3 = await generateSubjectline3(subjectPrompt);
                
                newSubjectLines[creativeType] = {
                    subject1: generatedSubjectline1 || 'Subject Line',
                    subject2: generatedSubjectline2 || 'Subject Line',
                    subject3: generatedSubjectline3 || 'Subject Line'
                };

                // Generate pre-header
                const preHeaderPrompt = `Create an email pre-header for a ${campaignType.toLowerCase()} campaign. Content: ${contentType}. Brief: ${briefDescription}. Max 90 characters.`;
                const generatedPreHeader = await generatePreHeader(preHeaderPrompt);
                newPreHeaders[creativeType] = generatedPreHeader || 'Pre-header text';
                
            } else if (creativeType === 'Push-Notification') {
                // Generate title for push notification
                const titlePrompt = `Create a push notification title for a ${campaignType.toLowerCase()} campaign. Content: ${contentType}. Brief: ${briefDescription}. Max 65 characters.`;
                const generatedHeadline = await generateHeadline(titlePrompt);
                newHeadlines[creativeType] = generatedHeadline || 'Push Title';
                
            } else if (creativeType === 'Popup') {
                // Generate headline for popup
                const headlinePrompt = `Create a compelling popup headline for a ${campaignType.toLowerCase()} campaign. Content: ${contentType}. Brief: ${briefDescription}. Max 50 characters.`;
                const generatedHeadline = await generateHeadline(headlinePrompt);
                newHeadlines[creativeType] = generatedHeadline || 'Popup Headline';
            }
        }
        
        setGeneratedContents(newGeneratedContents);
        setOriginalTexts(newOriginalTexts);
        setHeadlines(newHeadlines);
        setSubjectLines(newSubjectLines);
        setPreHeaders(newPreHeaders);
        setLikedContents({});
        
        hideLoading();
        setIsGenerating(false);
    };

    const handleLikeResponse = (creativeType, response) => {
        if (response === 'yes') {
            setLikedContents(prev => ({ ...prev, [creativeType]: true }));
        } else {
            setLikedContents(prev => ({ ...prev, [creativeType]: false }));
            // Regenerate only this specific creative type
            handleRegenerateForType(creativeType);
        }
    };

    const handleRegenerateForType = async (creativeType) => {
        setIsGenerating(true);
        showLoading();
        
        // Regenerate content for specific type
        let prompt = '';
        const campaignContext = `Campaign Type: ${campaignType}\nContent Type: ${contentType}\nTone: ${tone}\nBrief: ${briefDescription}`;
        
        switch(creativeType) {
            case 'Email':
                prompt = `Create an email campaign for a ${campaignType.toLowerCase()} campaign with the following details:
                ${campaignContext}
                
                Please provide ONLY the main email body content with proper HTML formatting:
                - Use <p> tags for paragraphs
                - Add <br> tags between paragraphs for proper spacing
                - Use <br> for line breaks within paragraphs
                - Use <strong> or <b> tags for important text and key points
                - Use <em> or <i> tags for emphasis where appropriate
                - Structure the content with proper spacing for readability
                - Make important offers, benefits, or calls-to-action stand out with bold formatting
                - Do NOT include subject lines, pre-header, or headline - just the email body text
                - Do NOT add quotation marks around the content
                - Return only the formatted HTML text content
                Keep it engaging and appropriate for the selected tone.`;
                break;
            case 'SMS':
                prompt = `Create a short SMS message (max 160 characters) for a ${campaignType.toLowerCase()} campaign:
                ${campaignContext}
                
                Provide ONLY plain text without any HTML formatting, emojis, or special characters.
                Do NOT add quotation marks around the content.
                Keep it concise, impactful, and within SMS character limits.`;
                break;
            case 'Push-Notification':
                prompt = `Create a push notification message for a ${campaignType.toLowerCase()} campaign:
                ${campaignContext}
                
                Provide ONLY the notification message body in plain text (max 240 characters). 
                Do not include HTML formatting, emojis, or special characters.
                Do not include the title/headline.
                Do NOT add quotation marks around the content.`;
                break;
            case 'Popup':
                prompt = `Create popup body text for a ${campaignType.toLowerCase()} campaign:
                ${campaignContext}
                
                Please provide ONLY the main popup body text with proper HTML formatting:
                - Use <p> tags for paragraphs
                - Add <br> tags between paragraphs for proper spacing
                - Use <br> for line breaks within paragraphs
                - Use <strong> or <b> tags for important text and key points
                - Use <em> or <i> tags for emphasis where appropriate
                - Structure the content with proper spacing for readability
                - Make important offers, benefits, or calls-to-action stand out with bold formatting
                - Do NOT include headline or CTA button text
                - Do NOT add quotation marks around the content
                - Return only the formatted HTML text content`;
                break;
        }
        
        const text = await generateText(prompt, tone, selectedLanguages);
        
        setGeneratedContents(prev => ({ ...prev, [creativeType]: text }));
        setOriginalTexts(prev => ({ ...prev, [creativeType]: text }));
        
        // Generate additional elements
        if (creativeType === 'Email') {
            const headlinePrompt = `Create a compelling email headline for a ${campaignType.toLowerCase()} email campaign. Content: ${contentType}. Brief: ${briefDescription}. Max 50 characters.`;
            const generatedHeadline = await generateHeadline(headlinePrompt);
            setHeadlines(prev => ({ ...prev, [creativeType]: generatedHeadline || 'Email Headline' }));

            const subjectPrompt = `Create email subject lines for a ${campaignType.toLowerCase()} campaign. Content: ${contentType}. Brief: ${briefDescription}`;
            const generatedSubjectline1 = await generateSubjectline1(subjectPrompt);
            const generatedSubjectline2 = await generateSubjectline2(subjectPrompt);
            const generatedSubjectline3 = await generateSubjectline3(subjectPrompt);
            
            setSubjectLines(prev => ({ 
                ...prev, 
                [creativeType]: {
                    subject1: generatedSubjectline1 || 'Subject Line',
                    subject2: generatedSubjectline2 || 'Subject Line',
                    subject3: generatedSubjectline3 || 'Subject Line'
                }
            }));

            const preHeaderPrompt = `Create an email pre-header for a ${campaignType.toLowerCase()} campaign. Content: ${contentType}. Brief: ${briefDescription}. Max 90 characters.`;
            const generatedPreHeader = await generatePreHeader(preHeaderPrompt);
            setPreHeaders(prev => ({ ...prev, [creativeType]: generatedPreHeader || 'Pre-header text' }));
            
        } else if (creativeType === 'Push-Notification') {
            const titlePrompt = `Create a push notification title for a ${campaignType.toLowerCase()} campaign. Content: ${contentType}. Brief: ${briefDescription}. Max 65 characters.`;
            const generatedHeadline = await generateHeadline(titlePrompt);
            setHeadlines(prev => ({ ...prev, [creativeType]: generatedHeadline || 'Push Title' }));
            
        } else if (creativeType === 'Popup') {
            const headlinePrompt = `Create a compelling popup headline for a ${campaignType.toLowerCase()} campaign. Content: ${contentType}. Brief: ${briefDescription}. Max 50 characters.`;
            const generatedHeadline = await generateHeadline(headlinePrompt);
            setHeadlines(prev => ({ ...prev, [creativeType]: generatedHeadline || 'Popup Headline' }));
        }
        
        hideLoading();
        setIsGenerating(false);
        setLikedContents(prev => ({ ...prev, [creativeType]: undefined })); // Reset to undefined to show feedback buttons again
    };

    const handleChannels = (selectedChannel) => {
        setChannels(prevChannels =>
            prevChannels.includes(selectedChannel)
                ? prevChannels.filter(channel => channel !== selectedChannel)
                : [...prevChannels, selectedChannel]
        );
    };

    const handleLanguages = (language) => {
        setSelectedLanguages(prevLanguages =>
            prevLanguages.includes(language)
                ? prevLanguages.filter(lang => lang !== language)
                : [...prevLanguages, language]
        );
    };

    useEffect(() => {
        if (selectedLanguages.length > 0 && Object.keys(generatedContents).length > 0) {
            const fetchTranslations = async () => {
                const translatedTexts = {};
                for (const creativeType of Object.keys(generatedContents)) {
                    translatedTexts[creativeType] = {};
                    for (const lang of selectedLanguages) {
                        const translated = await translateWithOpenAI(generatedContents[creativeType], lang);
                        if (translated) {
                            translatedTexts[creativeType][lang] = translated;
                        }
                    }
                }
                setTranslations(translatedTexts);
            };

            fetchTranslations();
        }
    }, [selectedLanguages, generatedContents]);

    const handleCreateContent = async () => {
        const approvedContents = Object.keys(likedContents).filter(type => likedContents[type] === true);
        
        if (approvedContents.length > 0 && contentName.trim() !== '') {
            setIsCreating(true);
            setCreationProgress(0);
            setTotalCreatives(approvedContents.length);
            showLoading();
            
            try {
                // Progress simulation
                const progressInterval = setInterval(() => {
                    setCreationProgress(prev => {
                        if (prev < 90) {
                            const increment = Math.random() * 15 + 5; // Random increment between 5-20%
                            return Math.min(prev + increment, 90);
                        }
                        return prev;
                    });
                }, 800);

                // Create content for each approved creative type
                for (let i = 0; i < approvedContents.length; i++) {
                    const creativeType = approvedContents[i];
                    setCurrentCreatingType(creativeType);
                    
                    let contentData = {};
                    let endpoint = '/translate/popup1'; // Default endpoint
                    
                    // Structure data based on creative type
                    switch(creativeType) {
                        case 'Email':
                            contentData = {
                                title: contentName,
                                creativeType: campaignType, // Use selected campaign type
                                creative: creativeType,
                                body: generatedContents[creativeType], // Main email body
                                headline: headlines[creativeType] || '', // Email headline
                                subjectLine1: subjectLines[creativeType]?.subject1 || '',
                                subjectLine2: subjectLines[creativeType]?.subject2 || '',
                                subjectLine3: subjectLines[creativeType]?.subject3 || '',
                                preHeader: preHeaders[creativeType] || '',
                                bodyBtnName: btnName,
                                originalText: originalTexts[creativeType],
                                languages: selectedLanguages,
                            };
                            break;
                            
                        case 'Push-Notification':
                            contentData = {
                                title: contentName,
                                creativeType: campaignType, // Use selected campaign type
                                creative: creativeType,
                                headline: headlines[creativeType] || '', // Push notification title
                                body: generatedContents[creativeType], // Push notification message
                                bodyBtnName: btnName,
                                originalText: originalTexts[creativeType],
                                languages: selectedLanguages,
                            };
                            break;
                            
                        case 'Popup':
                            contentData = {
                                title: contentName,
                                creativeType: campaignType, // Use selected campaign type
                                creative: creativeType, 
                                headline: headlines[creativeType] || '', // Popup headline
                                body: generatedContents[creativeType], // Popup body text
                                bodyBtnName: btnName,
                                originalText: originalTexts[creativeType],
                                languages: selectedLanguages,
                            };
                            break;
                            
                        case 'SMS':
                            // Use SMS specific endpoint and data structure
                            endpoint = '/translate/sms';
                            contentData = {
                                title: contentName,
                                creativeType: campaignType, // Use selected campaign type
                                body: generatedContents[creativeType], // SMS message
                                languages: selectedLanguages,
                            };
                            break;
                            
                        default:
                            contentData = {
                                title: `${contentName} - ${creativeType}`,
                                creativeType: campaignType, // Use selected campaign type
                                creative: creativeType,
                                body: generatedContents[creativeType],
                                originalText: originalTexts[creativeType],
                                languages: selectedLanguages,
                            };
                    }

                    const response = await axios.post(endpoint, contentData, {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('token')}`,
                        },
                    });

                    if (response.status !== 200) {
                        console.error(`Error: ${response.data.error}`);
                    }
                }
                
                clearInterval(progressInterval);
                setCreationProgress(100);
                setCurrentCreatingType('Finalizing...');

                // Wait a moment to show 100%
                await new Promise(resolve => setTimeout(resolve, 500));
                
                hideLoading();
                navigate('/library/creatives');
            } catch (error) {
                console.error('Error creating content:', error);
            } finally {
                setIsCreating(false);
                setCreationProgress(0);
                setCurrentCreatingType('');
                hideLoading();
            }
        } else {
            alert('Please fill in the content name and approve at least one generated content.');
        }
    };

    return (
        <div className="ai-assistant-container">
            {/* Header Section */}
            <div className="assistant-header">
                <h1 className="assistant-title">{pageTitle}</h1>
                <p className="assistant-subtitle">Generate engaging content with AI assistance</p>

                {/* Step Indicator */}
                <div className="step-indicator">
                    <div className="steps">
                        {[1, 2, 3].map((step) => (
                            <div
                                key={step}
                                className={`step ${currentStep >= step ? 'active' : ''} ${currentStep === step ? 'current' : ''}`}
                            >
                                <span className="step-number">{step}</span>
                                <span className="step-label">
                                    {step === 1 && 'Setup'}
                                    {step === 2 && 'Content & Brief'}
                                    {step === 3 && 'Generate & Review'}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Main Content Area */}
            <div className="assistant-content">
                {/* Step 1: Setup (Campaign Type + Creative Formats + Tone) */}
                {currentStep === 1 && (
                    <motion.div
                        className="step-section"
                        initial={{ opacity: 0, x: 20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.5 }}
                    >
                        <h3 className="step-title">Set Up Your Campaign</h3>
                        <p className="step-description">Tell us what you're creating, in what format, and in what tone.</p>

                        <div className="setup-subsection">
                            <h4 className="setup-subsection-title">1. What type of campaign is this?</h4>
                            <div className="campaign-type-grid">
                                {Object.entries(campaignTypesConfig || {
                                    Marketing: 'Marketing',
                                    System: 'System',
                                    Newsletter: 'Newsletter',
                                    Welcome: 'Welcome',
                                    Retention: 'Retention',
                                    Educational: 'Educational'
                                }).map(([key, value]) => {
                                    const campaignTypeInfo = {
                                        Marketing: { icon: '📈', description: 'Promotional campaigns, offers, product launches, sales' },
                                        System: { icon: '⚙️', description: 'Transactional messages, confirmations, notifications' },
                                        Newsletter: { icon: '📰', description: 'Regular updates, news, content sharing' },
                                        Welcome: { icon: '👋', description: 'Onboarding sequences, welcome messages, introductions' },
                                        Retention: { icon: '🔄', description: 'Re-engagement, win-back, loyalty campaigns' },
                                        Educational: { icon: '🎓', description: 'How-to guides, tips, tutorials, knowledge sharing' }
                                    };

                                    const info = campaignTypeInfo[key] || { icon: '📝', description: 'Custom campaign type' };

                                    return (
                                        <motion.div
                                            key={key}
                                            className={`campaign-type-card ${campaignType === value ? 'selected' : ''}`}
                                            onClick={() => setCampaignType(value)}
                                            whileHover={{ scale: 1.03 }}
                                            whileTap={{ scale: 0.95 }}
                                        >
                                            <div className="campaign-type-icon">{info.icon}</div>
                                            <div className="campaign-type-content">
                                                <h4>{value}</h4>
                                                <p>{info.description}</p>
                                            </div>
                                        </motion.div>
                                    );
                                })}
                            </div>
                        </div>

                        <div className="setup-subsection">
                            <h4 className="setup-subsection-title">2. Which formats do you need?</h4>
                            <p className="setup-subsection-hint">You can select more than one.</p>
                            <div className="creative-type-grid">
                                {[
                                    {
                                        name: 'Email',
                                        icon: <FiMail />,
                                        description: 'Full email campaign with subject lines, pre-header, and body'
                                    },
                                    {
                                        name: 'Push-Notification',
                                        icon: <FiSmartphone />,
                                        description: 'Mobile push notification with title and message'
                                    },
                                    {
                                        name: 'Popup',
                                        icon: <FiMessageSquare />,
                                        description: 'Website popup or banner with headline and CTA'
                                    },
                                    {
                                        name: 'SMS',
                                        icon: <FiMessageSquare />,
                                        description: 'Short text message (max 160 characters)'
                                    }
                                ].map((type) => (
                                    <motion.div
                                        key={type.name}
                                        className={`creative-type-card ${creativeTypes.includes(type.name) ? 'selected' : ''}`}
                                        onClick={() => {
                                            setCreativeTypes(prev =>
                                                prev.includes(type.name)
                                                    ? prev.filter(t => t !== type.name)
                                                    : [...prev, type.name]
                                            );
                                        }}
                                        whileHover={{ scale: 1.03 }}
                                        whileTap={{ scale: 0.95 }}
                                    >
                                        <div className="creative-type-icon">{type.icon}</div>
                                        <div className="creative-type-content">
                                            <h4>{type.name}</h4>
                                            <p>{type.description}</p>
                                        </div>
                                        {creativeTypes.includes(type.name) && (
                                            <div className="selection-indicator">✓</div>
                                        )}
                                    </motion.div>
                                ))}
                            </div>
                        </div>

                        <div className="setup-subsection">
                            <h4 className="setup-subsection-title">3. What tone should it have?</h4>
                            <div className="tone-buttons">
                                {toneOptions.map((option) => (
                                    <motion.button
                                        key={option}
                                        className={`tone-button ${tone === option ? 'active' : ''}`}
                                        onClick={() => setTone(option)}
                                        whileHover={{ scale: 1.05 }}
                                        whileTap={{ scale: 0.95 }}
                                    >
                                        {option}
                                    </motion.button>
                                ))}
                            </div>
                        </div>

                        <div className="step-navigation">
                            <div />
                            {canProceedToNextStep() && (
                                <motion.button
                                    className="next-step-button"
                                    onClick={handleNextStep}
                                    whileHover={{ scale: 1.05 }}
                                >
                                    Next: Content & Brief →
                                </motion.button>
                            )}
                        </div>
                    </motion.div>
                )}

                {/* Step 2: Content & Brief */}
                {currentStep === 2 && (
                    <motion.div
                        className="step-section"
                        initial={{ opacity: 0, x: 20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.5 }}
                    >
                        <h3 className="step-title">Describe Your Content</h3>
                        <p className="step-description">Give a short topic, then add the details our AI should use.</p>

                        <div className="setup-subsection">
                            <h4 className="setup-subsection-title">What would you like to create?</h4>
                            <div className="topic-input-container">
                                <textarea
                                    className="topic-input"
                                    placeholder="Describe your content (e.g., 'Promotional email for summer sale')"
                                    value={contentType}
                                    onChange={(e) => setContentType(e.target.value)}
                                    rows={3}
                                />
                            </div>
                        </div>

                        <div className="setup-subsection">
                            <h4 className="setup-subsection-title">Brief description</h4>
                            <div className="brief-input-container">
                                <textarea
                                    className="brief-input"
                                    placeholder={getBriefPlaceholder()}
                                    value={briefDescription}
                                    onChange={(e) => setBriefDescription(e.target.value)}
                                    rows={Math.max(5, creativeTypes.length * 3)}
                                />
                            </div>
                        </div>

                        <div className="step-navigation">
                            <button
                                className="back-step-button"
                                onClick={() => setCurrentStep(currentStep - 1)}
                            >
                                ← Back
                            </button>
                            {canProceedToNextStep() && (
                                <motion.button
                                    className="generate-button"
                                    onClick={() => {
                                        handleGenerate();
                                        handleNextStep();
                                    }}
                                    disabled={isGenerating}
                                    whileHover={{ scale: 1.03 }}
                                    whileTap={{ scale: 0.97 }}
                                >
                                    {isGenerating ? 'Generating...' : 'Generate Content →'}
                                </motion.button>
                            )}
                        </div>
                    </motion.div>
                )}

                {/* Step 3: Generate & Review */}
                {currentStep === 3 && Object.keys(generatedContents).length > 0 && (
                    <motion.div
                        className="step-section"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.3 }}
                    >
                        <h3 className="step-title">Review Your Generated Content</h3>
                        <p className="step-description">Approve each piece, or regenerate the ones that need work.</p>
                        <div className="multiple-content-preview">
                            {Object.entries(generatedContents).map(([creativeType, content]) => (
                                <div key={creativeType} className="content-type-section">
                                    <h4 className="content-type-title">{creativeType}</h4>
                                    <div className="content-preview">
                                        {creativeType === 'Email' && (
                                            <div className="email-preview">
                                                <div className="email-meta">
                                                    <h4>📧 Email Campaign Preview</h4>
                                                    <div className="email-subject">
                                                        <strong>Subject:</strong> {subjectLines[creativeType]?.subject1}
                                                    </div>
                                                    <div className="email-preheader">
                                                        <strong>Pre-header:</strong> {preHeaders[creativeType]}
                                                    </div>
                                                </div>
                                                <div className="email-content">
                                                    <div className="email-headline">
                                                        <h3>{headlines[creativeType] || 'Email Headline'}</h3>
                                                    </div>
                                                    <div className="email-body" dangerouslySetInnerHTML={{
                                                        __html: content || 'No email content available'
                                                    }}>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        
                                        {creativeType === 'Push-Notification' && (
                                            <div className="push-preview">
                                                <h4>📱 Push Notification Preview</h4>
                                                <div className="push-content">
                                                    <div className="push-title">
                                                        <strong>{headlines[creativeType] || 'Push Notification Title'}</strong>
                                                    </div>
                                                    <div className="push-body">
                                                        {content || 'No push notification content available'}
                                                    </div>
                                                </div>
                                                <div className="push-stats">
                                                    {(() => {
                                                        const titleStats = calculateTextStats(headlines[creativeType] || '');
                                                        const bodyStats = calculateTextStats(content || '');
                                                        const totalStats = {
                                                            characters: titleStats.characters + bodyStats.characters,
                                                            words: titleStats.words + bodyStats.words
                                                        };
                                                        return (
                                                            <div className="text-counter">
                                                                <div className="counter-row">
                                                                    <span className="counter-section">Title: {titleStats.characters} chars, {titleStats.words} words</span>
                                                                </div>
                                                                <div className="counter-row">
                                                                    <span className="counter-section">Body: {bodyStats.characters} chars, {bodyStats.words} words</span>
                                                                </div>
                                                                <div className="counter-row total">
                                                                    <span className="counter-section"><strong>Total: {totalStats.characters} characters, {totalStats.words} words</strong></span>
                                                                </div>
                                                            </div>
                                                        );
                                                    })()}
                                                </div>
                                            </div>
                                        )}
                                        
                                        {creativeType === 'Popup' && (
                                            <div className="popup-preview">
                                                <h4>💬 Popup Preview</h4>
                                                <div className="popup-content">
                                                    <div className="popup-headline">
                                                        <h3>{headlines[creativeType] || 'Popup Headline'}</h3>
                                                    </div>
                                                    <div className="popup-body" dangerouslySetInnerHTML={{
                                                        __html: content || 'No popup content available'
                                                    }}>
                                                    </div>
                                                </div>
                                                <div className="popup-stats">
                                                    {(() => {
                                                        const titleStats = calculateTextStats(headlines[creativeType] || '');
                                                        const bodyStats = calculateTextStats(content || '');
                                                        const totalStats = {
                                                            characters: titleStats.characters + bodyStats.characters,
                                                            words: titleStats.words + bodyStats.words
                                                        };
                                                        return (
                                                            <div className="text-counter">
                                                                <div className="counter-row">
                                                                    <span className="counter-section">Headline: {titleStats.characters} chars, {titleStats.words} words</span>
                                                                </div>
                                                                <div className="counter-row">
                                                                    <span className="counter-section">Body: {bodyStats.characters} chars, {bodyStats.words} words</span>
                                                                </div>
                                                                <div className="counter-row total">
                                                                    <span className="counter-section"><strong>Total: {totalStats.characters} characters, {totalStats.words} words</strong></span>
                                                                </div>
                                                            </div>
                                                        );
                                                    })()}
                                                </div>
                                            </div>
                                        )}
                                        
                                        {creativeType === 'SMS' && (
                                            <div className="sms-preview">
                                                <h4>📱 SMS Preview</h4>
                                                <div className="mobile-preview-container">
                                                    <div className="mobile-frame sms-frame">
                                                        <div className="mobile-header">
                                                            <div className="signal-bars">
                                                                <span></span><span></span><span></span><span></span>
                                                            </div>
                                                            <div className="time">12:34</div>
                                                            <div className="battery">🔋 100%</div>
                                                        </div>
                                                        <div className="sms-conversation">
                                                            <div className="sms-bubble received">
                                                                <div className="sms-text">
                                                                    {content || 'No SMS content available'}
                                                                </div>
                                                                <div className="sms-time">Now</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="sms-stats">
                                                    {(() => {
                                                        const stats = calculateSMSStats(content || '');
                                                        return (
                                                            <div className="text-counter">
                                                                <div className="counter-row">
                                                                    <span className="counter-section">Total Count: {stats.totalCount}</span>
                                                                </div>
                                                                <div className="counter-row">
                                                                    <span className="counter-section">Total SMS: {stats.totalSMS}</span>
                                                                </div>
                                                                <div className="counter-row">
                                                                    <span className="counter-section">GSM Characters: {stats.gsm}</span>
                                                                </div>
                                                                <div className="counter-row total">
                                                                    <span className="counter-section"><strong>Next Part: {stats.nextPart} characters remaining</strong></span>
                                                                </div>
                                                            </div>
                                                        );
                                                    })()}
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    {(likedContents[creativeType] === undefined || likedContents[creativeType] === null) && !isGenerating && (
                                        <div className="feedback-buttons">
                                            <p>Do you like this {creativeType.toLowerCase()} content?</p>
                                            <div className="feedback-actions">
                                                <motion.button
                                                    className="like-button"
                                                    onClick={() => handleLikeResponse(creativeType, 'yes')}
                                                    whileHover={{ scale: 1.05 }}
                                                >
                                                    <FiThumbsUp /> Yes, Keep This
                                                </motion.button>
                                                <motion.button
                                                    className="dislike-button"
                                                    onClick={() => handleLikeResponse(creativeType, 'no')}
                                                    whileHover={{ scale: 1.05 }}
                                                >
                                                    <FiThumbsDown /> Regenerate
                                                </motion.button>
                                            </div>
                                        </div>
                                    )}

                                    {likedContents[creativeType] === true && (
                                        <div className="approved-indicator">
                                            ✅ <strong>Approved!</strong> This content will be saved.
                                        </div>
                                    )}

                                    {likedContents[creativeType] === false && isGenerating && (
                                        <div className="regenerating-indicator">
                                            🔄 Regenerating content...
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>

                        {Object.values(likedContents).some(liked => liked === true) && (
                            <div className="final-actions">
                                <div className="name-input-container">
                                    <label className="input-label">Content Name</label>
                                    <input
                                        type="text"
                                        className="name-input"
                                        placeholder="Enter a name for your content"
                                        value={contentName}
                                        onChange={(e) => setContentName(e.target.value)}
                                    />
                                </div>

                                {/* Language Selection */}
                                <div className="language-section">
                                    <h4 className="section-subtitle">Select Languages</h4>
                                    <div className="language-tags">
                                        {activeLanguages.map((lang) => (
                                            <motion.div
                                                key={lang._id}
                                                className={`language-tag ${selectedLanguages.includes(lang._id) ? 'selected' : ''}`}
                                                onClick={() => handleLanguages(lang._id)}
                                                whileHover={{ scale: 1.05 }}
                                            >
                                                <FiGlobe /> {lang.code.toUpperCase()}
                                            </motion.div>
                                        ))}
                                    </div>
                                </div>

                                {contentName.trim() !== '' && (
                                    <motion.button
                                        className="create-button"
                                        onClick={handleCreateContent}
                                        disabled={isCreating}
                                        whileHover={{ scale: 1.05 }}
                                    >
                                        {isCreating ? (
                                            <>
                                                <span className="button-spinner"></span>
                                                Creating...
                                            </>
                                        ) : (
                                            `Create ${Object.values(likedContents).filter(liked => liked === true).length} Content(s) & Go to Library`
                                        )}
                                    </motion.button>
                                )}
                            </div>
                        )}

                        <div className="step-navigation">
                            <button 
                                className="back-step-button" 
                                onClick={() => setCurrentStep(currentStep - 1)}
                            >
                                ← Back
                            </button>
                        </div>
                    </motion.div>
                )}

                {/* Loading State */}
                {isGenerating && (
                    <div className="loading-overlay">
                        <div className="loading-content">
                            <div className="spinner"></div>
                            <p>Generating your content...</p>
                        </div>
                    </div>
                )}

                {/* Loading State for Creation with Progress Bar */}
                {isCreating && (
                    <div className="translation-loading-overlay">
                        <div className="translation-loading-content">
                            <div className="translation-header">
                                <h2>Creating Content</h2>
                                <p>Please wait while we create your content in the selected formats</p>
                            </div>
                            
                            <div className="translation-progress">
                                <div className="progress-circle">
                                    <svg className="progress-ring" width="120" height="120">
                                        <circle
                                            className="progress-ring-circle-bg"
                                            stroke="#e5e7eb"
                                            strokeWidth="8"
                                            fill="transparent"
                                            r="52"
                                            cx="60"
                                            cy="60"
                                        />
                                        <circle
                                            className="progress-ring-circle"
                                            stroke="#E66239"
                                            strokeWidth="8"
                                            fill="transparent"
                                            r="52"
                                            cx="60"
                                            cy="60"
                                            style={{
                                                strokeDasharray: `${2 * Math.PI * 52}`,
                                                strokeDashoffset: `${2 * Math.PI * 52 * (1 - creationProgress / 100)}`,
                                                transform: 'rotate(-90deg)',
                                                transformOrigin: '50% 50%'
                                            }}
                                        />
                                    </svg>
                                    <div className="progress-text">
                                        <span className="progress-percentage">{Math.round(creationProgress)}%</span>
                                    </div>
                                </div>
                                
                                <div className="translation-info">
                                    <div className="translation-stats">
                                        <div className="stat">
                                            <span className="stat-label">Creatives to create:</span>
                                            <span className="stat-value">{totalCreatives}</span>
                                        </div>
                                        <div className="stat">
                                            <span className="stat-label">Progress:</span>
                                            <span className="stat-value">{Math.round(creationProgress)}%</span>
                                        </div>
                                    </div>
                                    
                                    {currentCreatingType && (
                                        <div className="current-language">
                                            <span className="current-language-label">Currently creating:</span>
                                            <span className="current-language-name">{currentCreatingType}</span>
                                        </div>
                                    )}
                                    
                                    <div className="progress-bar">
                                        <div className="progress-bar-bg">
                                            <div 
                                                className="progress-bar-fill"
                                                style={{ width: `${creationProgress}%` }}
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ContentGenerator;
